import { HierarchyLevels } from '@retail/products/types';
import { ConditionBinding } from './CreateConditions';

export interface BindingValuesProps {
  supplierItemId?: number;
  gtinCode?: string;
  groupCode?: string;
  groupNumber?: string;
  supplierNumber?: number;
  mgItemNumber?: number;
}

export const toConditionBinding = ({
  supplierItemId,
  gtinCode,
  groupCode,
  groupNumber,
  supplierNumber,
  mgItemNumber,
}: BindingValuesProps): ConditionBinding => {
  if (supplierItemId) {
    return { mgSupplierItem: { supplierItemId, gtinCode } };
  } else if (!supplierNumber) {
    return { assortment: { activeLevel: true } };
  } else if (mgItemNumber) {
    return { legacySupplierItem: { mgItemNumber, supplierNumber, gtinCode } };
  } else if (groupCode) {
    return { discountGroup: { groupCode, supplierNumber } };
  } else if (groupNumber) {
    return { productGroup: { groupNumber, supplierNumber } };
  } else {
    return { supplier: { supplierNumber } };
  }
};

export const bindingFromHierarchyLevel = (
  bindingType: HierarchyLevels,
  bindingTargetId: string,
  supplierNumber?: number
): ConditionBinding =>
  toConditionBinding({
    supplierNumber,
    groupCode: bindingType === 'DISCOUNT_GROUP' ? bindingTargetId : undefined,
    groupNumber: ['OVERGRUPPE', 'HOVEDGRUPPE', 'VAREGRUPPE'].includes(bindingType)
      ? bindingTargetId
      : undefined,
    mgItemNumber: bindingType === 'MG_SUPPLIER_ITEM' ? Number(bindingTargetId) : undefined,
  });
